// @flow
import React, { useMemo } from 'react';
import VectorSource from 'ol/source/Vector';
import type { Zone as ZoneType } from '../../../types';
import { ZINDEX } from '../../../constants/appConstants';
import { layers, interactions } from '../../ui/openlayers';
import Zone from './Zone';
import Drawing from './Drawing';
import { makeStyleFunction } from './style';

const source = new VectorSource();

export type Props = $ReadOnly<{
    permanentList: $ReadOnlyArray<$PropertyType<ZoneType, 'id'>>,
    temporaryList: $ReadOnlyArray<$PropertyType<ZoneType, 'id'>>,
    showInactiveZones: boolean,
    drawingEnabled: boolean,
    drawingZoneId?: string,
}>;

function Zones({ permanentList, temporaryList, showInactiveZones, drawingEnabled, drawingZoneId }: Props) {
    const style = useMemo(() => ({
        default: makeStyleFunction({
            showInactive: showInactiveZones
        }),
        selected: makeStyleFunction({
            showInactive: true
        })
    }), [showInactiveZones]);

    return (
        <layers.Vector label="zones" source={source} style={style.default} zIndex={ZINDEX.zones}>
            {!drawingEnabled && <interactions.Select label="selectZones" multi style={style.selected}/>}

            <Drawing />

            {permanentList.map((id) => (drawingEnabled && drawingZoneId === id ? null : <Zone key={id} id={id} />))}
            {temporaryList.map((id) => (drawingEnabled && drawingZoneId === id ? null : <Zone key={id} id={id} />))}
        </layers.Vector>
    );
}

export default Zones;